import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import axios from './axios'
import store from './store'
import './assets/stylus/main.styl'
import { Button, Toast, Loading, RadioGroup, Radio, Tab, Tabs, Dialog, Field, CountDown, Icon, Form, Checkbox, CheckboxGroup, Popup, Picker, DatetimePicker, Cell, List, Tag, Sidebar, SidebarItem, Tabbar, TabbarItem, Swipe, SwipeItem, Stepper, Area, AddressEdit, NavBar, CellGroup, SubmitBar, Image, Search, ImagePreview, Progress, Overlay } from 'vant'
import lottery from 'vue-lottery'

Vue.use(VueRouter)
Vue.use(axios)
Vue.use(lottery)

const vantComponents = { Button, Toast, Loading, RadioGroup, Radio, Tab, Tabs, Dialog, Field, CountDown, Icon, Form, Checkbox, CheckboxGroup, Popup, Picker, DatetimePicker, Cell, List, Tag, Sidebar, SidebarItem, Tabbar, TabbarItem, Swipe, SwipeItem, Stepper, Area, AddressEdit, NavBar, CellGroup, SubmitBar, Image, Search, ImagePreview, Progress, Overlay }
Object.keys(vantComponents).forEach(key => {
  Vue.use(vantComponents[key])
})

let ua = window.navigator.userAgent
let app = window.navigator.appVersion
if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  document.body.addEventListener('focusout', () => {
    var currentPosition, timer
    var speed = 1
    timer = setInterval(function () {
        currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        currentPosition -= speed
        window.scrollTo(0, currentPosition)
        currentPosition += speed
        window.scrollTo(0, currentPosition)
        clearInterval(timer)
    }, 100)
  })
}

// console.log('当前VUE_APP_CURRENTMODE：' + process.env.VUE_APP_CURRENTMODE)

Vue.config.productionTip = false
Vue.prototype.$fetch = axios
Vue.prototype.$store = store

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
